<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
            <h3 class="country-heading"><strong>Study in Europe</strong></h3>
            <p> Of the major geographical regions, Europe was the first to establish a modern economy based on industrialization, commercial agriculture, and the supply of specialized services. Its successful modernization can be attributed to the continent's abundant economic resources, its long history of inventions, the development of a skilled and educated labour force, and the interconnectedness of all its parts—both naturally occurring and man-made—which made it possible for enormous amounts of raw materials and finished goods to be transported easily as well as for ideas to be exchanged.</p>
            <p>Education and a highly-regarded career hold significant importance in modern society. Students begin contemplating their career choices and ideal university options while they are still in school. The desire to pursue higher education in a foreign country is prevalent among the majority of potential students. This article aims to assist you in selecting the path for your career and identifying the area of the globe that is worth exploring to achieve your aspirations. In truth, the professions that are considered the most esteemed, well-known, and significant are facing a shortage of skilled and knowledgeable professionals. Europe accommodates a significant amount of people from various countries across the globe. Europe is in need of jobs that are in high demand.</p>
            <p><strong>Why people want to study in European country?</strong></p>
            <p>The continent that greatly impacts our present civilization, particularly in the contemporary era, offers excellent opportunities for pursuing advanced studies. It is justifiable that studying in Europe is a favored option for international education. The continent encompasses all significant historical and cultural feats, and coupled with advancements in technology and research, it contains everything essential. In Europe, there are universities that offer free education and scholarships for international students. For students who are interested in studying overseas, a comprehensive guide to Europe and all it has to offer is available. If we see closely, some of the pros of the study in Europe are –</p>
            <ul>
              <li>Europe gives exposures to global education and research system.</li>
              <li>Plenty of options to study and opportunities.</li>
              <li>Universal Language English is applicable everywhere.</li>
              <li>Affordable tuition fees compared to other countries.</li>
              <li>Scholarships available.</li>

          </ul>
          <h3 class="country-heading"><strong>Study Process in Europe</strong></h3>
          <p>Europe has been considered as one of the premium study destinations accredited globally for quite a few decades now. Not like other countries, Europe consists of fifty other sovereign states most of which are highly developed in terms of best academic infrastructure and delivery of highly valued education. Among these countries Visa related rules are differently applicable for different states. Here the types of visas and relevant information are given:</p>
<p><strong>A visa that allows entry to countries within the Schengen region of Europe.</strong></p>
          <p>For duration of up to three months, international students seeking to travel to Schengen countries for academic reasons are provided with a provisional student visa. After the expiration of this visa, it is possible to renew it. Moreover, if a student is chosen for the visa program, he or she is eligible to request a residency permit. If the chosen institution doesn't require it, one can get a Schengen study visa without having to take the IELTS tests or any other language exams. It is recommended to confirm the admission and visa criteria before submitting an application, since each country has its own process for evaluating visa applications, and the regulations differ for each person. It is recommended for the candidates to maintain.</p>
          <p><strong>Europe visa for students with an extended duration.</strong></p>
          <p>International students are typically granted the Long-Stay Study visa if they are enrolled in courses and programs that require them to remain in the country for more than six months. The residency permit is encompassed within this visa.</p>
          <p><strong>Obtaining a student visa for language courses in Europe.</strong></p>
          <p>It is compulsory for students desiring to enroll in courses or programs taught in the native language of the host country to possess a certain level of skill in that language. Situations may occur where a student needs to travel to Europe to take a language-focused examination. The usefulness of this visa becomes apparent.</p>
          <p><strong>Visa for students applying.</strong></p>
          <p>The universities' reactions to students' applications vary in certain circumstances.</p>
          <p><strong>Documents Required for Europe Visa</strong></p>
          <p>When a student chooses to study abroad and begins the process of submitting applications to different universities, it is crucial for them to ensure that their necessary documents are in order as well. In order to obtain a visa, the following are the requisite conditions for visa application.</p>


          <ul>
            <li>Application form for a visa to enter.</li>
            <li>Current photographs in the size required for a passport.</li>
            <li>Travel documents that are in accordance with the rules and regulations.</li>
            <li>Verification of lodgings in Europe.</li>
            <li>Demonstration of adequate financial backing for the student's education and living expenses during their time in Europe.</li>
            <li>Health insurance that requires payment.</li>
            <li>A duplicate of all educational certificates obtained prior to this point.</li>
            <li>The letter of acceptance that was received from the University of his/her choice after applying.</li>
            <li>Receiving the fees for the visa application.</li>

          </ul>

           <h4 class="country-heading"><strong>Some popular Universities Europe 2023 and their rank</strong></h4>


          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Sl No.</th>
                            <th>Popular University</th>
                            <th style="text-align: center;">QS ranking</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="text-align: center;">1.</td>
                            <td>University of Cambridge</td>
                            <td style="text-align: center;">2</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">2.</td>
                            <td>University of Oxford</td>
                            <td style="text-align: center;">4</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">3.</td>
                            <td>Imperial College London</td>
                            <td style="text-align: center;">6</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">4.</td>
                            <td>University College London (UCL)</td>
                            <td style="text-align: center;">8</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">5.</td>
                            <td>ETH Zurich</td>
                            <td style="text-align: center;">9</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">6.</td>
                            <td>The University of Ediburgh</td>
                            <td style="text-align: center;">15</td>
                          </tr>
                          <tr>
                            <td style="text-align: center;">7</td>
                            <td>University of Manchester</td>
                            <td style="text-align: center;">28</td>
                          </tr>
                        </tbody>
                      </table>
          </div>

    
          <h4 ><strong>Popular UG courses, required documents and fees in Europe:</strong></h4>
          <p ><strong>Documents required for UG course applications:</strong></p>
             <p>1) Application Form</p>
             <p>2) 10th Mark sheet and Certificate –Notary attested</p>
             <p>3) 12th Mark sheet and Certificate- Notary attested</p>
             <p>4) Passport Copy – First and Last Page – Notary attested</p>
             <p>5) Letters of Recommendation – 2</p>
             <p>6) Statement of Purpose (Duly Signed by Student)</p>
             <p>7) Resume.</p>
             <p>8) IELTS or TOEFL score card if required–Notary attested</p>
             <p>9) Experience certificate – if any</p>
             <p>10) Birth Certificate</p>
             <p>11) Photograph</p>



          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th>Popular Universities</th>
                            <th>Popular UG Courses</th>
                            <th>Fees Structure(1St year)</th>
                            <th>Exams</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>University of East London</td>
                            <td>
                              <ul>
                                <li>Bachelor of engineering</li>
                                <li>BBA</li>
                                <li>B.Sc</li>
                                <li>BHM</li>
                              </ul>
                            </td>
                            <td>
                             
                              12.67L-13.87L<br>
                              13.69L<br>
                              13.45L-13.69L<br>
                              13.69L<br>
                            
                            </td>
                            <td>IELTS,GRE,GMAT</td>
                          </tr>

                          <tr>
                            <td>King’s College London</td>
                            <td>
                              <ul>
                                <li>BBA</li>
                                <li>MBBS</li>
                                <li>B.Sc</li>
                              </ul>
                            </td>
                            <td>
                            
                                20.72 L - 31.15 L<br>
                                40.65 L - 45.26 L<br>
                                20.72 L - 34.79 L<br>
                           
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Greenwich</td>
                            <td>
                              <ul>
                                <li>B.Tech</li>
                                <li>BBA</li>
                                <li>B.Sc</li>
                              </ul>
                            </td>
                            <td>
                            
                                15.05L<br>
                                15.05L<br>
                                14.45L-15.05L<br>
                           
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Hertfordshire</td>
                            <td>
                              <ul>
                                <li>B.Tech</li>
                                <li>BBA</li>
                                <li>B.Sc</li>
                              </ul>
                            </td>
                            <td>
                              12.95L-13.95L <br>
                              12.95L-14.7L <br>
                              12.95L-13.95L <br>
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Manchester</td>
                            <td>
                              <ul>
                                <li>B.Tech</li>
                                <li>B.Sc</li>
                                <li>BBA</li>
                                <li>BA</li>
                              </ul>
                            </td>
                            <td>
                              20.92 L - 30.89 L <br>
                              22.92 L - 29.89 L <br>
                              19.43 L - 28.9 L <br>
                              19.43 L - 20.92 L
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Leeds</td>
                            <td>
                              <ul>
                            
                                <li>B.Sc</li>
                                <li>BBA</li>
                                <li>BA</li>
                              </ul>
                            </td>
                            <td>
                              20.72 L - 34.79 L <br>
                              20.72 L - 31.15 L <br>
                              20.72 L - 27.95 L <br>
                            </td>
                            <td></td>
                          </tr>

                        </tbody>
                      </table>
          </div>

          <p><strong>Popular PG courses, required documents and fees in Europe:</strong></p>
            <p>Documents required for PG course applications:</p>
            <p><strong>Popular UG courses, required documents and fees in Europe:</strong></p>

          <p><strong>Documents required for PG course applications:</strong></p>
            <p>1) Application Form</p>
            <p>2) 10th Mark sheet and Certificate –Notary attested</p>
            <p>3) 12th Mark sheet and Certificate- Notary attested</p>
            <p>4) Bachelor’s Degree – All individual Mark sheets and consolidated Mark sheet- Notary attested </p>
            <p>5) Degree Certificate or Provisional Degree Certificate- Notary attested</p>
            <p>6) Passport Copy – First and Last Page – Notary attested5) Degree Certificate or Provisional Degree Certificate- Notary attested</p>
            <p>7) Letters of Recommendation – 2</p>
            <p>8) Statement of Purpose (Duly Signed by Student)</p>
            <p>9) Resume.</p>
            <p>10) IELTS or TOEFL score card if required–Notary attested</p>
            <p>11) Experience certificate – if any</p>
            <p>12) Birth Certificate </p>
            <p>13) Photograph</p>


            <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th>Popular Universities</th>
                            <th>Popular PG Courses</th>
                            <th>Fees Structure(1St year)</th>
                            <th>Exams</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>University of East London</td>
                            <td>
                              <ul>
                                <li>MBA/PGDM</li>
                                <li>MS</li>
                                <li>MIM</li>
                              </ul>
                            </td>
                            <td>
                             
                              12.67L-13.87L<br>
                              13.69L<br>
                              13.45L-13.69L<br>
                              13.69L<br>
                  
                            </td>
                            <td>IELTS,GRE,SAT</td>
                          </tr>

                          <tr>
                            <td>King’s College London</td>
                            <td>
                              <ul>
                                <li>MIM</li>
                                <li>MS</li>
                                <li>M.A</li>
                              </ul>
                            </td>
                            <td>
                            
                                20.72 L - 31.15 L<br>
                                40.65 L - 45.26 L<br>
                                20.72 L - 34.79 L<br>
                           
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Greenwich</td>
                            <td>
                              <ul>
                                <li>MIM</li>
                                <li>M.Arch</li>
                                <li>Executive MBA/PGDM</li>
                              </ul>
                            </td>
                            <td>
                            
                                15.05L<br>
                                15.05L<br>
                                14.45L-15.05L<br>
                           
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Hertfordshire</td>
                            <td>
                              <ul>
                                <li>MS</li>
                                <li>MIM</li>
                                <li>MBA/PGDM</li>
                              </ul>
                            </td>
                            <td>
                              12.95L-13.95L <br>
                              12.95L-14.7L <br>
                              12.95L-13.95L <br>
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Manchester</td>
                            <td>
                              <ul>
                                <li>MS</li>
                                <li>MIM</li>
                                <li>MBA/PGDM</li>
                              </ul>
                            </td>
                            <td>
                              20.92 L - 30.89 L <br>
                              22.92 L - 29.89 L <br>
                              19.43 L - 28.9 L <br>
                              19.43 L - 20.92 L
                            </td>
                            <td>IELTS</td>
                          </tr>

                          <tr>
                            <td>University of Leeds</td>
                            <td>
                              <ul>
                            
                                <li>MS</li>
                                <li>MIM</li>
                                <li>MBA/PGDM</li>
                              </ul>
                            </td>
                            <td>
                              20.72 L - 34.79 L <br>
                              20.72 L - 31.15 L <br>
                              20.72 L - 27.95 L <br>
                            </td>
                            <td></td>
                          </tr>

                        </tbody>
                      </table>
          </div>

          <h4 class="country-heading"><strong>Visa Application Processes:</strong></h4>
           <p><strong>How to apply for a visa to come to the UK?</strong></p>
           <p>A visa could be required for those who wish to study, work, visit or reunite with family in the UK.</p>
           <p>Visas may vary depending on:</p>
           <p>What is your place of origin?</p>
           <p>What is the reason for your desire to visit the UK?</p>
           <p>Individual situation and abilities.</p>
           <p>The duration on will be staying there.</p>
           <p>It is necessary to verify whether a visa is required and which category of visa is needed prior to submitting the application. It is possible that you may not require a visa to travel or transit through the UK, depending on your nationality.</p>
           <p>Prior to your travel, your application needs to be sanctioned.</p>
           <p>As an Irish citizen, you are exempt from the requirement to obtain a visa.</p>
           <p><strong>Apply on GOV.UK</strong></p>
           <p>Complete the online application form on https://visas-immigration.service.gov.uk/apply-uk-visa Remember to apply for visa well before the decided travel dates.</p>
           <p>Typically, the earliest time to submit an application is:</p>
           <p>For visit visas, three months prior to your intended travel date.For most work visas, it is necessary to apply three months prior to the start date of employment.</p>
           <p>For Student and Child Student visas, the course start date should be at least 6 months in advance.</p>
            <p>You must get approval for settlement applications before coming to the UK, a process that can take up to 6 months. If your authorization to reside in the UK is granted, it is essential that you travel within the allotted time frame before it expires.</p>
            <p><strong>Charges</strong></p>
            <p>A visa incurs a charge. The cost varies according to the type of visa being applied for. All family members who submit an application to accompany you to the UK will be charged the identical fees.</p>
            <p><strong>For preparing the application</strong></p>
             <ul>
              <li>One has to prove identity and provide documents to show the eligibility.</li>
              <li>One needs to go to an appointment at visa application centre.</li>
              <li>One needs to download the app “UK immigration – ID check” in smart phone.</li>

             </ul>

            <h4 ><strong>Career opportunity and job Employability in UK</strong></h4>
             <p>Although the UK has the fifth biggest economy and several significant business centers within it, there continues to be a scarcity of qualified employees. Explore the fields that are welcoming new graduates and learn how to apply for relevant positions.</p>
             <p>The country's unemployment rate is at 3.7%, which is relatively low, and the graduate labor market is as strong as it has been in a while. Although there is intense competition for graduate jobs, individuals who possess the necessary credentials, abilities, and experience stand a decent chance of finding employment. Linguistic proficiency is becoming more and more vital, making many foreigners viable candidates. You will be in excellent company as a foreign worker in the UK, which has numerous multinational communities. It’s not surprising that the UK is a popular choice for overseas graduates looking to launch their careers given the country's diversified employment sectors, favorable working conditions, and abundance of employment chances.</p>
             <p>The UK employment rate was estimated at 75.6% in October-December 2022, up 0.2 percentage points from the previous three-month period. The increase in employment in the last three months was due to part-time workers. The latest estimate of wage workers for January 2023 again shows a monthly increase of 102,000 from the  December 2022 revision to 30.0 million.</p>

           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
